"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKProvider = void 0;
const api_client_1 = require("./api-client");
const override_console_methods_1 = require("./browser-integration/override-console-methods");
const print_to_console_1 = require("./browser-integration/print-to-console");
const register_browser_events_handler_1 = require("./browser-integration/register-browser-events-handler");
const register_error_handler_1 = require("./browser-integration/register-error-handler");
const register_ui_events_handler_1 = require("./browser-integration/register-ui-events-handler");
const call_info_factory_1 = require("./call-info-factory");
const channel_1 = require("./channel");
const connection_1 = require("./connection");
const current_session_1 = require("./current-session");
const database_1 = require("./data/database");
const device_keys_table_1 = require("./data/device-keys.table");
const in_memory_storage_1 = require("./data/in-memory.storage");
const issues_table_1 = require("./data/issues.table");
const logs_table_1 = require("./data/logs.table");
const sessions_table_1 = require("./data/sessions.table");
const device_1 = require("./device");
const http_client_1 = require("./http-client");
const log_factory_1 = require("./log-factory");
const logger_1 = require("./logger");
const reset_storage_1 = require("./reset-storage");
const sdk_options_1 = require("./sdk-options");
const session_factory_1 = require("./session-factory");
const storage_guard_1 = require("./storage-guard");
const storage_processor_1 = require("./storage-processor");
const storage_writer_1 = require("./storage-writer");
const storage_writer_handler_1 = require("./storage-writer.handler");
const storage_writer_hub_1 = require("./storage-writer.hub");
const user_feedback_1 = require("./user-feedback");
const utils_1 = require("./utils");
const uuid_factory_1 = require("./uuid-factory");
const browser_1 = require("./browser");
const storage_writer_worker_1 = __importDefault(require("./storage-writer.worker"));
const cache = new Map();
const Cached = (0, utils_1.CacheDecoratorFactory)(cache);
class SDKProvider {
    constructor(apiFeatures, operationModes, sdkUserAgent, version, window) {
        this.apiFeatures = apiFeatures;
        this.operationModes = operationModes;
        this.sdkUserAgent = sdkUserAgent;
        this.version = version;
        this.window = window;
        this.uuidFactory = new uuid_factory_1.UUIDFactory();
        this.console = window.console;
    }
    setOptions(options) {
        this.options = options;
    }
    getApiClient() {
        const httpClient = new http_client_1.HttpClient(this.options.apiURL, this.options.appKey, this.sdkUserAgent);
        return new api_client_1.ApiClient(this.options.appKey, httpClient);
    }
    getBrowser() {
        return new browser_1.Browser(this.window);
    }
    getChannel() {
        return __awaiter(this, void 0, void 0, function* () {
            let channel;
            if (yield this.operationModes.isMultiTab()) {
                channel = new channel_1.Channel((0, channel_1.createBroadcastChannel)(), this.getLogger('Channel'));
            }
            else {
                channel = new channel_1.MonoChannel();
            }
            this.getCurrentSession().then((currentSession) => {
                channel.setCurrentSession(currentSession);
            });
            return channel;
        });
    }
    getConnection() {
        return new connection_1.Connection(this.window);
    }
    getCurrentSession() {
        return __awaiter(this, void 0, void 0, function* () {
            return new current_session_1.CurrentSession(this.getDevice(), this.getLogger('CurrentSession'), this.getSessionStorage(), yield this.getSessionsTable(), this.uuidFactory);
        });
    }
    getDatabase() {
        return new database_1.Database();
    }
    getDevice() {
        return new device_1.Device(this.getBrowser(), this.getLocalStorage(), this.version, this.uuidFactory);
    }
    getDeviceKeysTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.operationModes.isMultiTab()) {
                return new device_keys_table_1.IDBDeviceKeysTable(this.getDatabase().devicekeys);
            }
            else {
                return new device_keys_table_1.InMemoryDeviceKeysTable();
            }
        });
    }
    getIssuesTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.operationModes.isMultiTab()) {
                return new issues_table_1.IDBIssuesTable(this.getDatabase().issues);
            }
            else {
                return new issues_table_1.InMemoryIssuesTable();
            }
        });
    }
    getLogger(tag) {
        if (this.options.debug) {
            return new logger_1.ConsoleLogger(this.console, tag);
        }
        else {
            return new logger_1.NoopLogger();
        }
    }
    getLogsTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.operationModes.isMultiTab()) {
                return new logs_table_1.IDBLogsTable(this.getDatabase().logs, new log_factory_1.LogFactory());
            }
            else {
                return new logs_table_1.InMemoryLogsTable(new log_factory_1.LogFactory(), 3000);
            }
        });
    }
    getOverrideConsoleMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            return new override_console_methods_1.OverrideConsoleMethods(yield this.getStorageWriterHub(), this.window);
        });
    }
    getPrintToConsole() {
        return new print_to_console_1.PrintToConsole(this.console);
    }
    getRegisterBrowserEventsHandler() {
        return __awaiter(this, void 0, void 0, function* () {
            return new register_browser_events_handler_1.RegisterBrowserEventsHandler(yield this.getStorageWriterHub(), this.window);
        });
    }
    getRegisterErrorHandler() {
        return __awaiter(this, void 0, void 0, function* () {
            return new register_error_handler_1.RegisterErrorHandler(this.window);
        });
    }
    getRegisterUIEventsHandler() {
        return __awaiter(this, void 0, void 0, function* () {
            return new register_ui_events_handler_1.RegisterUIEventsHandler(yield this.getStorageWriterHub(), this.window);
        });
    }
    getResetStorage() {
        return __awaiter(this, void 0, void 0, function* () {
            return new reset_storage_1.ResetStorage(this.apiFeatures, yield this.getCurrentSession(), this.getDatabase(), this.getLocalStorage(), this.getSessionStorage());
        });
    }
    getSDKOptions() {
        return new sdk_options_1.SDKOptions(this.getBrowser());
    }
    getStorageGuard() {
        return __awaiter(this, void 0, void 0, function* () {
            return new storage_guard_1.StorageGuard(this.getApiClient(), yield this.getDevice(), this.options);
        });
    }
    getStorageProcessor() {
        return __awaiter(this, void 0, void 0, function* () {
            const sessionFactory = new session_factory_1.SessionFactory(this.getDevice(), this.version, this.window);
            return new storage_processor_1.StorageProcessor(this.getApiClient(), yield this.getChannel(), this.getConnection(), this.getLogger('StorageProcessor'), this.getDevice(), yield this.getDeviceKeysTable(), yield this.getIssuesTable(), yield this.getLogsTable(), this.options, sessionFactory, yield this.getSessionsTable(), yield this.getStorageGuard());
        });
    }
    getStorageWriterHub() {
        return __awaiter(this, void 0, void 0, function* () {
            const isMultiThread = yield this.operationModes.isMultiThread();
            let handler;
            if (isMultiThread) {
                handler = new storage_writer_worker_1.default();
            }
            else {
                handler = new storage_writer_handler_1.MainThreadStorageWriterHandler(new storage_writer_1.StorageWriter(yield this.getDeviceKeysTable(), yield this.getIssuesTable(), new log_factory_1.LogFactory(), yield this.getLogsTable()));
            }
            return new storage_writer_hub_1.StorageWriterHub(new call_info_factory_1.CallInfoFactory(), yield this.getChannel(), this.getDevice(), handler, this.options, yield this.getCurrentSession(), yield this.getStorageGuard(), this.uuidFactory, this.window);
        });
    }
    getLocalStorage() {
        if (this.apiFeatures.isLocalStorageSupported()) {
            return this.window.localStorage;
        }
        else {
            return new in_memory_storage_1.InMemoryStorage();
        }
    }
    getSessionStorage() {
        if (this.apiFeatures.isSessionStorageSupported()) {
            return this.window.sessionStorage;
        }
        else {
            return new in_memory_storage_1.InMemoryStorage();
        }
    }
    getSessionsTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.operationModes.isMultiTab()) {
                return new sessions_table_1.IDBSessionsTable(this.getDatabase().sessions);
            }
            else {
                return new sessions_table_1.InMemorySessionsTable();
            }
        });
    }
    getUserFeedback() {
        return __awaiter(this, void 0, void 0, function* () {
            return new user_feedback_1.UserFeedback(yield this.getStorageWriterHub());
        });
    }
}
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], SDKProvider.prototype, "getApiClient", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], SDKProvider.prototype, "getBrowser", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getChannel", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", connection_1.Connection)
], SDKProvider.prototype, "getConnection", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getCurrentSession", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", database_1.Database)
], SDKProvider.prototype, "getDatabase", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], SDKProvider.prototype, "getDevice", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getDeviceKeysTable", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getIssuesTable", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getLogsTable", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getOverrideConsoleMethods", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", print_to_console_1.PrintToConsole)
], SDKProvider.prototype, "getPrintToConsole", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getRegisterBrowserEventsHandler", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getRegisterErrorHandler", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getRegisterUIEventsHandler", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getResetStorage", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", sdk_options_1.SDKOptions)
], SDKProvider.prototype, "getSDKOptions", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getStorageGuard", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getStorageProcessor", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getStorageWriterHub", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Storage)
], SDKProvider.prototype, "getLocalStorage", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Storage)
], SDKProvider.prototype, "getSessionStorage", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getSessionsTable", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SDKProvider.prototype, "getUserFeedback", null);
exports.SDKProvider = SDKProvider;
